export default "__VITE_ASSET__C1H49eE1__"